const apiUrl = process.env.REACT_APP_API_URL;
export const PutProblemesIdEstat = async (id_activitat: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes/${id_activitat}/estat`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
